<template>
  <div
    ref="container"
    class="w-full h-full"
  />
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import * as THREE from 'three'
import {
  initScene,
  createParticles,
  updateParticles,
  applyDirectionalForce
} from '@/composables/useParticlePhysics'
import {
  setupMouseTracking,
  getSwipeRay
} from '@/composables/useMouseInteraction'

const container = ref(null)


let scene, camera, renderer, geometry, particleSystem
let positions, velocities
let cleanupMouse
const clock = new THREE.Clock()

onMounted(() => {
  requestAnimationFrame(() => {
    if (!container.value) {
      console.error('❌ container not available')
      return
    }

    const { scene: s, camera: c, renderer: r } = initScene(container.value)
    scene = s
    camera = c
    renderer = r

    const particleData = createParticles()
    geometry = particleData.geometry
    positions = particleData.positions
    velocities = particleData.velocities

    const material = new THREE.PointsMaterial({
      size: 1.8,
      color: 0x88ccff
    })

    particleSystem = new THREE.Points(geometry, material)
    scene.add(particleSystem)

 cleanupMouse = setupMouseTracking(container.value, (swipeVector, mouseVec2) => {
 // console.log("🌀 swipe detected:", swipeVector)
  const ray = getSwipeRay(camera, mouseVec2)
  const centerHit = ray.origin.clone().add(ray.direction.clone().multiplyScalar(50)) // pushes 50 units into the sphere
 // console.log("🌀 ray:", ray)

  applyDirectionalForce(positions, velocities, centerHit, ray.direction, 100, 100)
}, {
  minSwipeDistance: 0.002,
  passMouseVec: true
})


    animate()
  })
})

onBeforeUnmount(() => {
  if (cleanupMouse) cleanupMouse()
  if (renderer) renderer.dispose()
})

function animate() {
  requestAnimationFrame(animate)
  const delta = clock.getDelta()
  updateParticles(positions, velocities, 0.985, delta)
  geometry.attributes.position.needsUpdate = true
  renderer.render(scene, camera)
}
</script>

<style scoped>
div {
  width: 100%;
  height: 100vh;
  overflow: hidden;
}
canvas {
  display: block;
}
</style>
